import { GTMWindow, LoadStatus, PromiseOfTracking, TrackableEvent, TrackingConfig } from '../model';
import { UserData } from '@utils/gtm-tracking/model/UserData';

export const pushEventFactory =
    (
        windowReference: GTMWindow,
        config: TrackingConfig,
        trackingObjectPromise: Promise<LoadStatus>,
        globalParamExtractor?: () => Record<string, any>
    ) =>
    (event: TrackableEvent): PromiseOfTracking =>
        new Promise(resolve => {
            trackingObjectPromise.then(({ status, rejectionReason }) => {
                if (status === 'ERROR') {
                    resolve({
                        success: false,
                        message: `Error: Rejected tracking ${event.event}. ${rejectionReason}`
                    });
                }
                if (status === 'READY') {
                    const timeout = setTimeout(() => {
                        resolve({
                            success: false,
                            message: `Error: Event timed out ${event.event}`
                        });
                    }, config.trackingTimeoutMs);

                    prePushAction(windowReference, event);

                    windowReference.dataLayer.push({
                        ...pushEvent(event, globalParamExtractor),
                        eventCallback: () => {
                            clearTimeout(timeout);
                            resolve({ success: true });
                        }
                    });
                }
            });
        });

/**
 * Resets ecommerce object before pushing a new ecommerce event
 * @param windowReference
 * @param event
 */
const prePushAction = (windowReference: GTMWindow, event: TrackableEvent & { ecommerce?: any }): void => {
    if (event.ecommerce) {
        windowReference.dataLayer.push({ ecommerce: null });
    }
};

/**
 * Attaches data to the event which is shared across events
 * @param event
 * @param userIdExtractor
 * @param extractor
 * @returns
 */
const pushEvent = (
    event: TrackableEvent,
    extractor?: () => Record<string, any>
): TrackableEvent & { userData?: UserData } => {
    const extracted = extractor?.();

    if (extracted) {
        return { ...extracted, ...event };
    }

    return event;
};
